import queryParams from '../../common/service/queryParams';
import TrimLevelType from '../enum/TrimLevelType';
import { useLocation } from 'react-router';
import { Filters } from '../../../__generated__/globalTypes';
import { useParams } from 'react-router-dom';
import IParams from '../../gqlCustomise/model/IParams';

const useCollectedFilters = () => {
  const location = useLocation();
  const { trimCode } = useParams<IParams>();
  const modelCode = queryParams.getParam(TrimLevelType.MODEL, location);
  const variantCode = queryParams.getParam(TrimLevelType.VARIANT_ID, location);
  const engineCode = queryParams.getParam(TrimLevelType.ENGINE, location);
  const specPackCode = queryParams.getParam(TrimLevelType.SPECIFICATION_PACK, location);
  const bodyStyleCode = queryParams.getParam(TrimLevelType.BODY_STYLE, location);

  const filters: Filters = {
    trimCode: decodeURIComponent(trimCode),
    modelCode,
    variantCode,
    engineCode,
    specPackCode,
    bodyStyleCode,
  };

  return { filters };
};

export default useCollectedFilters;
